import React, { createContext, FC, PropsWithChildren, useContext } from 'react';

export type UserData = { isLoggedIn: false } | { isLoggedIn: true; userId: string };

const UserDataContext = createContext<UserData | undefined>(undefined);

export const useUserData = () => {
  const userData = useContext(UserDataContext);
  if (userData === undefined) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return userData;
};

export const UserDataContextProvider: FC<PropsWithChildren<{ userData: UserData }>> = ({ children, userData }) => {
  return <UserDataContext.Provider value={userData}>{children}</UserDataContext.Provider>;
};
